import React, { Component } from 'react';
import { Segment, Modal } from 'semantic-ui-react';
import ReactTable from 'react-table';
class ListAccounts extends Component {

    render() {
        const { accounts } = this.props;
        return (
            <Modal size="small" open={this.props.open} onClose={this.props.close} closeIcon>
                <Modal.Header>Click on a row below to select an account:</Modal.Header>
                <Modal.Content>
                    <Segment.Group>
                        <Segment>
                            <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={accounts.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                                data={accounts}
                                getNoDataProps={() => {
                                    return { style: { display: 'none' } };
                                }}
                                getTrProps={(state, rowInfo) => {
                                    return {
                                        onClick: (e) => {
                                            this.props.enableSubmit(rowInfo.original)
                                        },
                                        style: {
                                            cursor: "pointer",
                                            color: "#1e70bf"
                                        }
                                    }
                                }}
                                columns={[{
                                    Header: this.props.t("client.account"),
                                    accessor: 'acoInvoiceId',
                                    width: 110,
                                    style: {
                                        textAlign: "left"
                                    }
                                }, {
                                    Header: this.props.t("our.account"),
                                    accessor: 'acoAccountId',
                                    width: 100,
                                    style: {
                                        textAlign: "right"
                                    }
                                }, {
                                    Header: 'Name',
                                    id: 'conLastName',
                                    accessor: row => (
                                        row.conFirstName + " " + row.conLastName
                                    ),
                                    style: {
                                        textAlign: "left"
                                    }
                                }, {
                                    Header: 'SSN',
                                    id: 'conSsn',
                                    accessor: row => (
                                        row.conSsn ? this.props._padString(row.conSsn.toString()) : ""
                                    ),
                                    width: 100,
                                    style: {
                                        textAlign: "right"
                                    }
                                }, {
                                    Header: 'Total',
                                    id: 'acoTotal',
                                    width: 100,
                                    style: {
                                        textAlign: "right"
                                    },
                                    accessor: row => (
                                        this.props._currencyFormat(row.acoTotal)
                                    )
                                }, {
                                    Header: 'Status',
                                    accessor: 'acoStatusCode',
                                    width: 60,
                                    style: {
                                        textAlign: "center"
                                    }
                                }]}
                            />
                        </Segment>
                    </Segment.Group>
                </Modal.Content>
            </Modal>
        );
    }
}
export default ListAccounts;


// WEBPACK FOOTER //
// ./src/app/ui/cancellations/ListAccounts.js